
import { Component, OnInit, Output, EventEmitter, OnDestroy, Input, TemplateRef, ViewChild } from '@angular/core';
import { Router, Resolve } from '@angular/router';
import { ContractService } from '../../../services/contract.service';
import { AccountService } from '../../../services/account.service';
import { AddcontractComponent } from './contract/addcontract/addcontract.component';
import { LoginViewModel } from '../../../models/login-view-model';
import { Location } from '@angular/common';
// import {Subscription } from 'rxjs/Subscription';
import { Contract } from '../../../models/Contract';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { ModalComponent } from './../../../shared-components/modal/modal.component';
import { userProfile } from '../../../models/userProfile';


@Component({
  selector: 'app-my-contracts',
  templateUrl: './my-contracts.component.html',
  styleUrls: ['./my-contracts.component.scss']
})
export class MyContractsComponent implements OnDestroy, OnInit {
  // private subscription: Subscription;
  public view: string;
  public dtOptions: any;
  public contracts: any;
  public contractPg = 1;
  public rowsOnPage = 2;
  public sortBy = 'InvoiceBalance';
  public sortOrder = 'asc';
  needToShow: boolean;
  modalRef: BsModalRef;

  // Carousel
  currentIndex = 0;
  speed = 5000;
  infinite = true;
  autoplay = true;
  avatars: any[];
  carouselHeight = '360px';
  carouselWidth = '600px';
  /* public user = {
     username: 'ITtester',
     password: 'myjssi2015'
   } as LoginViewModel;*/
  public setCurrentCard: any;
  showNotifications = true;
  @ViewChild('templateAddContract') templateAddContract: ModalComponent;
  @ViewChild('templateNewPaymentInstructions') templateNewPaymentInstructions: ModalComponent;
  @ViewChild('templateMTSForm') templateMTSForm: ModalComponent;
  @ViewChild('addContract') addContract: AddcontractComponent;
  @ViewChild('bankinfo') bankinfo: ModalComponent;
  alive = true;


  constructor(private accountService: AccountService,
    private modalService: BsModalService,
    private router: Router,
    location: Location,
    public contractService: ContractService) {
    router.events.subscribe(() => {
      this.needToShow = true;
      if (location.path().indexOf('/contract/') > -1) {
        this.needToShow = false;
      }
    });
  }

  ngOnInit() {
    /// this.getContracts(true);
    this.avatars = [
      // {url: '../../../../assets/img/MyJSSI Ad CO2 CALCULATOR.png', isDark: false, title: 'JSSI Sustainability' },
      // {url: '../../../../assets/img/MyJSSI Ad CDD.png', isDark: false, title: 'JSSI CDD' },
      // {url: '../../../../assets/img/MyJSSI Ad JPL.png', isDark: false, title: 'JPL' },
      // {url: '../../../../assets/img/MyJSSI Ad MEM.png', isDark: false, title: 'MEM' },
      //  {url: '../../../../assets/img/MyJSSI Ad NEWS.png', isDark: false, title: 'NEWS' },
      // {url: '../../../../assets/img/carousel/MyJSSI_Ad_PH.png', isDark: false, title: 'Parts Hub' }
      {url: '../../../../assets/img/carousel/MyJSSI Rebrand Ad-1.png', isDark: false, title: 'JSSI' }

      // {url: '../../../../assets/img/Sustainability_MyJSSI_EDIT.png', isDark: false, title: 'JSSI Sustainability' },
    //  { url: '../../../../assets/img/carousel/myJSSI_July_2021_SierraTrax.png', isDark: false, title: 'JSSI SierraTrax' },
    //  { url: '../../../../assets/img/carousel/myJSSI_May_2021.png', isDark: false, title: 'JSSI Launch' }

 // Recent ones
      // { url: '../../../../assets/img/carousel/myJSSI_CDD.png', isDark: false, title: 'CDD' },
      // { url: '../../../../assets/img/carousel/myJSSI_JPL.png', isDark: false, title: 'JSSI Parts' },
      // { url: '../../../../assets/img/carousel/myJSSI_JAS.png', isDark: false, title: 'JSSI advs' },
      // { url: '../../../../assets/img/carousel/myJSSI_SierraTrax.png', isDark: false, title: 'SierraTrax' },
      // { url: '../../../../assets/img/carousel/myJSSI_Traxxall.png', isDark: false, title: 'Traxxall' },
      // { url: '../../../../assets/img/carousel/JSSI_MX_Software_Ad.jpg', isDark: false, title: 'MXSoftware' }


    //  { url: '../../../../assets/img/carousel/MYjssi_postLogin.png', isDark: false, title: 'JSSI Launch' }
    //  { url: '../../../../assets/img/carousel/myJSSI_ADSB.jpg', isDark: false, title: 'ADS-B' },
   // { url: '../../../../assets/img/carousel/myJSSI_2020.jpg', isDark: false, title: 'MYJSSI' },
    //  { url: '../../../../assets/img/carousel/myJSSI_advisory.jpg', isDark: false, title: 'advisory' },
    //  { url: '../../../../assets/img/carousel/myJSSI_ConklinDD.jpg', isDark: false, title: 'ConklinDD' },
    //  { url: '../../../../assets/img/carousel/myJSSI_JSSI_parts.jpg', isDark: false, title: 'parts' },
    //  { url: '../../../../assets/img/carousel/myJSSI_ConklinNew.jpg', isDark: false, title: 'ConklinDD' },
    //  { url: '../../../../assets/img/carousel/myJSSI_PartsPortal.jpg', isDark: false, title: 'partsPortal' }
     ];
    if (!this.contractService.contracts) {
      this.contractService.getContractList()
        .takeWhile(() => this.alive)
        .subscribe(data => {
          if (data && data.length > 8) {
            this.view = 'list';
          } else {
            this.view = 'grid';
          }

          console.log('Contracts reloaded.');
        });

      //   this.contracts = await this.contractService.getContractListPromise();
    } else {

      // alert('contracts not reloaded');
      if (this.contractService.contracts && this.contractService.contracts.length > 9) {
        this.view = 'list';
      } else {
        this.view = 'grid';
      }
    }


    // if (!this.contractService.contracts) {

    //   console.log('logloglog: start refetching contracts from my-contracts.');
    //   this.getContracts(true);

    // } else {
    //   console.log('logloglog: ' + this.contractService.contracts.length);

    // }

    this.dtOptions = { paging: false, searching: false, sorting: true };
    this.onOpenMTSFormModal();
  }

  public clickGridView() {
    this.view = 'grid';
    console.log('the view: ', this.view);
  }

  public clickListView() {
    this.view = 'list';
    console.log('the view: ', this.view);
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

  onOpenModal() {
    this.addContract.clearData();
    this.templateAddContract.show();
  }

  onOpenPaymentInstructionModal() {
    this.templateNewPaymentInstructions.show();
  }

  onClosePaymentInstructionModal() {
    this.templateNewPaymentInstructions.hide();
  }
  onOpenMTSFormModal() {
   // console.log('onOpenMTSFormModal: ', this.view);
  //  this.templateMTSForm.show();
  }
  onCloseMTSFormModal() {
  //  this.templateMTSForm.hide();
  }

  onCloseModal($event) {
    this.addContract.clearData();
    this.templateAddContract.hide();
    //  window.scrollTo(0, 0);
  }

  getContracts(reload: boolean) {
    this.contractService.getContractList()
      .takeWhile(() => this.alive)
      .subscribe(
        data => {
          console.log(data);
          this.contracts = data;
          if (this.contracts.length > 8) {
            this.view = 'list';
          } else {
            this.view = 'grid';
          }
          //     this.contractService.contracts = data;
        },
        err => {

          console.log(err);
        }
      );
  }

  public checkInvTotal(total: any) {
    let tempTotal;
   // const re = /-/gi;
    console.log('total', total);
    // let placeClass: string;
    // let placetotal: string;
    // placetotal = total;
    // if (total < 0) {
    //   tempTotal = '(' + placetotal.replace( '-', '') + ')';
    // } else {
      tempTotal = total;
    // }

//console.log(tempTotal);

    return tempTotal;
  }

  public checkDue(status: any) {
    let isLate: boolean;

    return isLate;
  }
  btnContractClick(card: any, $event: Event) {
    // this.setCurrentCard = card;

    // console.log(this.contractService.selectedContract);

    this.router.navigate([`/pages/client/my-contracts/contract/${card.ContractNumber}/overview`]);
  }

  adClick() {
    this.router.navigate([`/pages/marketplace`]);
  }

  click(i) {
    switch (i + 1) {
     /*  case 1:
       window.open('https://conklindedecker.jetsupport.com/co2-calculator?utm_source=myjssi&utm_medium=banner&utm_campaign=cO2', '_blank');
      break;
       case 2:
        this.router.navigate([`/pages/myjssi-bundle`]);
        break;

     
     case 3:
       window.open('https://jetsupport.com/parts-and-leasing/?utm_source=myjssi&utm_medium=banner&utm_campaign=JPL', '_blank');
    
       break;
     case 4:
        
        window.open('https://jetsupport.com/advisory-services/aircraft-maintenance-management/?utm_source=myjssi&utm_medium=banner&utm_campaign=MEM', '_blank');
         break;
         case 5:
         
         window.open('https://jetsupport.com/news-events-case-studies/?utm_source=myjssi&utm_medium=banner&utm_campaign=news%2Bevents', '_blank');
         break;
         case 6:
         window.open('https://jetsupport.com/partshub/?utm_source=myjssi&utm_medium=banner&utm_campaign=PH', '_blank');
         break; */
    }
  }

  public btnSubmitHoursClick(card: any, $event: Event) {

    $event.stopPropagation();
    if (this.contractService.selectedContract) {
      this.contractService.selectedContract.ContractNumber = card.ContractNumber;
    }
    this.router.navigateByUrl(`/pages/client/my-contracts/contract/${card.ContractNumber}/flight-hours?submithours=true`);
    /// this.router.navigateByUrl(`/pages/client/my-contracts/contract/${card.ContractNumber}/fh-error`);
  }

  public btnPayInvoicesClick(card: any, $event: Event) {
    $event.stopPropagation();
    // this._accountSerivce.pushContractToComponents(info);
    this.router.navigateByUrl(`/pages/client/my-contracts/contract/${card.ContractNumber}/financials?payInvoices=true`);
  }

  public btnMarketplaceClick($event: Event) {
    $event.stopPropagation();
    this.router.navigateByUrl(`/pages/client/marketplace`);
  }

  ngOnDestroy() {
    this.alive = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/client/my-contracts/my-contracts.component.ts